import { component } from 'picoapp';

export default component(async (node) => {
  const breadcrumbs = node.querySelectorAll('[data-breadcrumb]');
  const backBtn = node.querySelector('[data-back-btn]');

  const deTruncrate = (event) => {
    event.preventDefault();
    breadcrumbs.forEach((breadcrumb: HTMLElement) => {
      if (!breadcrumb.dataset.originalText) return;
      breadcrumb.textContent = breadcrumb.dataset.originalText;
      breadcrumb.removeEventListener('click', deTruncrate);
    });
  };

  const truncate = (breadcrumb: HTMLElement) => {
    breadcrumb.dataset.originalText = breadcrumb.textContent;
    breadcrumb.textContent = '...';
    breadcrumb.addEventListener('click', deTruncrate);
  };

  const initBreadcrumbs = () => {
    backBtn.addEventListener('click', () => {
      window.history.back();
    });

    if (window.matchMedia('(max-width: 640px)').matches) {
      for (let i = 0; i <= breadcrumbs.length - 3; i += 1) {
        truncate(breadcrumbs[i] as HTMLElement);
      }
    }
    node.classList.remove('hidden');
    node.classList.add('flex');
  };

  const init = () => {
    initBreadcrumbs();
  };

  init();
});
